



















































































































































































import Vue, { PropType } from "vue";

export interface PaypalCustomCardFieldsData {
  doUseSettings: string;
  agreements: string[];
  needAgreementsAllowCount: number;
  isValid: boolean;
  hostedFields: any;
}

export interface GoldAutochargePaypalInputCardInformationFormProps {
  sdkUrl: string;
  purchaseApiUrl: string;
  completedUrl: string;
  cancelCompletedUrl: string;
  errorUrl: string;
  backUrl: string;
  usageStatus: string;
  clientToken: string;
  csrfToken: string;
  translationResources: object;
  termsOfUseUrl: string;
  informationUrl: string;
  goldTermsOfUseUrl: string;
  paypalInputCardInformationFormWrappedRecaptchaProps: object;
}

export default Vue.extend({
  name: "vc-gold-autocharge-paypal-input-card-information-secure-form",
  props: {
    sdkUrl: {
      type: String as PropType<
        GoldAutochargePaypalInputCardInformationFormProps["sdkUrl"]
      >,
      default: ""
    },
    purchaseApiUrl: {
      type: String as PropType<
        GoldAutochargePaypalInputCardInformationFormProps["purchaseApiUrl"]
      >,
      default: ""
    },
    completedUrl: {
      type: String as PropType<
        GoldAutochargePaypalInputCardInformationFormProps["completedUrl"]
      >,
      default: ""
    },
    cancelCompletedUrl: {
      type: String as PropType<
        GoldAutochargePaypalInputCardInformationFormProps["cancelCompletedUrl"]
      >,
      default: ""
    },
    errorUrl: {
      type: String as PropType<
        GoldAutochargePaypalInputCardInformationFormProps["errorUrl"]
      >,
      default: ""
    },
    backUrl: {
      type: String as PropType<
        GoldAutochargePaypalInputCardInformationFormProps["backUrl"]
      >,
      default: ""
    },
    usageStatus: {
      type: String as PropType<
        GoldAutochargePaypalInputCardInformationFormProps["usageStatus"]
      >,
      default: ""
    },
    clientToken: {
      type: String as PropType<
        GoldAutochargePaypalInputCardInformationFormProps["clientToken"]
      >,
      default: ""
    },
    csrfToken: {
      type: String as PropType<
        GoldAutochargePaypalInputCardInformationFormProps["csrfToken"]
      >,
      default: ""
    },
    translationResources: {
      type: Object as PropType<
        GoldAutochargePaypalInputCardInformationFormProps["translationResources"]
      >,
      default: () => {}
    },
    termsOfUseUrl: {
      type: String as PropType<
        GoldAutochargePaypalInputCardInformationFormProps["termsOfUseUrl"]
      >,
      default: ""
    },
    informationUrl: {
      type: String as PropType<
        GoldAutochargePaypalInputCardInformationFormProps["informationUrl"]
      >,
      default: ""
    },
    goldTermsOfUseUrl: {
      type: String as PropType<
        GoldAutochargePaypalInputCardInformationFormProps["goldTermsOfUseUrl"]
      >,
      default: ""
    },
    paypalInputCardInformationFormWrappedRecaptchaProps: {
      type: Object as PropType<
        GoldAutochargePaypalInputCardInformationFormProps["paypalInputCardInformationFormWrappedRecaptchaProps"]
      >,
      default: () => {}
    }
  },
  mounted() {
    this.needAgreementsAllowCount = document.getElementsByName(
      "agreements"
    ).length;
  },
  data(): PaypalCustomCardFieldsData {
    return {
      needAgreementsAllowCount: 2,
      doUseSettings: "1",
      agreements: [],
      isValid: false,
      hostedFields: {}
    };
  },
  computed: {
    isUseSettings(): boolean {
      // オートチャージを 1: 利用する, 0: 利用しない
      return this.doUseSettings === "1";
    },
    isCurrentlyUsed(): boolean {
      // 利用状況 1: 利用中, 0: 利用していない
      return this.usageStatus === "1";
    },
    isAllChecked(): boolean {
      return this.needAgreementsAllowCount === this.agreements.length;
    }
  },
  methods: {
    catchValid(value: boolean) {
      this.isValid = value;
    },
    catchHostedFields(value: object) {
      this.hostedFields = value;
    }
  }
});
